import { Component } from '@angular/core';
import { companyInformation } from '../../../companyinformation';
import { SeoService } from "../../../core/services/seo.service";
import { nav_path } from "../../../app-routing.module";
import { FirestoreService } from "../../../shared/services/firestore.service";
import { Observable, tap, throwError } from "rxjs";
import { Project } from "../../../shared/interfaces/project";
import { catchError, map } from "rxjs/operators";
import { ConsoleLoggerService } from "../../../core/services/console-logger.service";

@Component({
  selector: 'anon-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.scss']
})
export class PortfolioComponent {
  public readonly company = companyInformation;
  public projects$?: Observable<Project[]>;
  public error?: Error;

  constructor(
    private seo: SeoService,
    private db: FirestoreService,
    private cLog: ConsoleLoggerService
  ) {
    this.seo.generateTags({
      title: 'Portfolio page',
      route: nav_path.portfolio
    });

    this.projects$ = (this.db.colQuery$(`projects`) as Observable<Project[]>)
      .pipe(
        map(projects => projects.sort((a, b) => a?.order - b?.order)),
        catchError(error => {
        this.cLog.error(`error getting portfolio projects`, error);
        this.error = error;
        return throwError(error);
      })
      );
  }

}
